/**
 * Constantes puras del módulo plinko: límites y valores de balance que no
 * dependen de Phaser ni de Matter. Las comparte tanto la capa de lógica pura
 * (`plinko/logic/*`, testeada con Vitest) como la capa de render
 * (`Board`, `BallPool`, `PlinkoView`, ...).
 */

/**
 * Tope de bolas físicas visibles a la vez. El contador lógico del vertido es
 * siempre la verdad; por encima de este tope cada bola visual representa una
 * porción proporcional del total real (ver `distributeBallWeights`).
 */
export const MAX_VISUAL_BALLS = 120;

/** Factor que aplica una barra negativa: resta 25% del valor que porta la bola. */
export const NEGATIVE_FACTOR = 0.75;

/** Rango de valores posibles al revelar una barra misteriosa (2..7, inclusive). */
export const MYSTERY_MIN = 2;
export const MYSTERY_MAX = 7;

/** Rango válido de valores para barras multiplicadoras (x2..x7, inclusive). */
export const MULT_MIN = 2;
export const MULT_MAX = 7;
